/* tslint:disable */
/* eslint-disable */
/**
 * My App
 * This is an awesome app!
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Todo
 */
export interface Todo {
    /**
     * 
     * @type {number}
     * @memberof Todo
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Todo
     */
    content: string;
    /**
     * 
     * @type {boolean}
     * @memberof Todo
     */
    isDone: boolean;
}

/**
 * Check if a given object implements the Todo interface.
 */
export function instanceOfTodo(value: object): value is Todo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('isDone' in value) || value['isDone'] === undefined) return false;
    return true;
}

export function TodoFromJSON(json: any): Todo {
    return TodoFromJSONTyped(json, false);
}

export function TodoFromJSONTyped(json: any, ignoreDiscriminator: boolean): Todo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'content': json['content'],
        'isDone': json['isDone'],
    };
}

export function TodoToJSON(json: any): Todo {
    return TodoToJSONTyped(json, false);
}

export function TodoToJSONTyped(value?: Todo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'content': value['content'],
        'isDone': value['isDone'],
    };
}

